import { useTranslations } from "use-intl";

import { CloseIcon, SearchIcon } from "@/components/appIcons";

export function FacetSearchInput({
  onChange,
  onClear,
  placeholder,
  value,
  visible,
}: {
  onChange: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
  value: string;
  visible: boolean;
}) {
  const t = useTranslations("facets");
  const ta = useTranslations("globals.accessibility");
  if (!visible) return null;

  return (
    <div className="relative w-full">
      <SearchIcon className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground text-[18px] pointer-events-none" />
      <input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder ?? t("searchPlaceholder")}
        className="pl-9 pr-8 h-11 sm:h-10 w-full bg-secondary/50 border border-border rounded-md text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
      />
      {value && (
        <button
          type="button"
          aria-label={ta("clearSearch")}
          onClick={onClear}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
        >
          <CloseIcon className="text-[16px]" />
        </button>
      )}
    </div>
  );
}
